import { render, staticRenderFns } from "./cowsAbove18Months.vue?vue&type=template&id=5888074c&scoped=true&"
import script from "./cowsAbove18Months.vue?vue&type=script&lang=js&"
export * from "./cowsAbove18Months.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5888074c",
  null
  
)

export default component.exports